/**
 * CardStyleControls — Container-level card style settings (border, shadow, hover).
 *
 * Rendered at the top of CardEditorPanel. Uses PresetControl for segmented selections.
 */

import { PresetControl } from './controls'
import type { ContainerConfig } from './card-editor-types'
import { BORDER_OPTIONS, SHADOW_OPTIONS, HOVER_OPTIONS } from './card-editor-types'

interface CardStyleControlsProps {
  config: ContainerConfig
  onChange: (key: keyof ContainerConfig, value: string) => void
}

export function CardStyleControls({ config, onChange }: CardStyleControlsProps) {
  return (
    <div className="space-y-4 rounded-sm bg-gray-50 p-3">
      <h3 className="text-xs font-medium uppercase tracking-wider text-gray-400">
        Card Style
      </h3>
      <PresetControl
        value={config.border}
        onChange={(v) => onChange('border', v)}
        label="Border"
        options={BORDER_OPTIONS}
      />
      <PresetControl
        value={config.shadow}
        onChange={(v) => onChange('shadow', v)}
        label="Shadow"
        options={SHADOW_OPTIONS}
      />
      <PresetControl
        value={config.hover}
        onChange={(v) => onChange('hover', v)}
        label="Hover Effect"
        options={HOVER_OPTIONS}
      />
    </div>
  )
}
